import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api-giveahand.herokuapp.com',
  // baseURL:
  //   'https://cors-anywhere.herokuapp.com/https://api-giveahand.herokuapp.com',
  // baseURL: 'http://localhost:3333',
});

export default api;
